// say we got date string in some var:
export const convertDate = (dateString) => {
  const [year, month, day] = [...dateString.split("-")];
  const monthIndex = month - 1;
  const jsBirthDate = new Date(year, monthIndex, day);
  return jsBirthDate.toLocaleDateString('et-EE');
};
